const UNKNOWN = 'unknown'

export function formatDepthHeightValues(depthHeightStart, depthHeightEnd) {
  if (!depthHeightStart && !depthHeightEnd) return ''

  let precision = 0.000001
  let depthHeightStartFloat = parseFloat(depthHeightStart)
  let depthHeightEndFloat = parseFloat(depthHeightEnd)

  if (depthHeightStartFloat == null) {
    depthHeightStartFloat = UNKNOWN
  }

  if (depthHeightEndFloat == null) {
    depthHeightEndFloat = UNKNOWN
  }

  if (Math.abs(depthHeightStartFloat - depthHeightEndFloat) <= precision) {
    return depthHeightStartFloat
  } else {
    return `<strong>${depthHeightStartFloat}</strong> to <strong>${depthHeightEndFloat}</strong> meters`
  }
}

export function generateDatumText(p) {
  let datumName = (p.Datum && p.Datum.DatumName)
  let datumType = (p.Datum && p.Datum.DatumType && p.Datum.DatumType.Name)
  let datumText = (datumName && datumType && (`${datumName} (${datumType})`)) || ''
  return datumText
}